module.exports = __webpack_public_path__ + "img/dtQ.ad4ad650.svg";